import idx from 'idx';
import request from 'axios';
import reduce from 'lodash/reduce';
import some from 'lodash/some';
import difference from 'lodash/difference';
import moment from 'moment';
import queryString from 'query-string';
import { createAction } from 'redux-actions';
import { updateSubcatWatchlists } from 'common/ducks/user';
import { getWatchableCategories } from 'common/ducks/categories';
import { fetchSettings as fetchNotificationSettings } from 'account/ducks/notification_settings';
import { setBannerError } from 'error';
import {
  UNVERIFIED_RESOURCE_NAME, CLIENTS_RESOURCE_NAME, CREATIVES_RESOURCE_NAME, WAITERS_RESOURCE_NAME,
  USER_PROJECTS_RESOURCE_NAME, USER_PAYMENTS_RESOURCE_NAME, USER_PAYMENTS_PAGE_SIZE,
  CREATIVE_PROJECTS_PAGE_SIZE, WAITER_INVITES_RESOURCE_NAME
} from 'admin/constants';
import { getAPIQueryString } from 'common/utils';
import { savePageCount } from 'common/pager/ducks';

/* ACTIONS
================================================================================================ */
const FETCH_UNVERIFIED = 'crowdspring/admin/FETCH_UNVERIFIED';
const FETCH_UNVERIFIED_REQUEST = 'crowdspring/admin/FETCH_UNVERIFIED_REQUEST';
const FETCH_UNVERIFIED_SUCCESS = 'crowdspring/admin/FETCH_UNVERIFIED_SUCCESS';

const FETCH_UNVERIFIED_STATS = 'crowdspring/admin/FETCH_UNVERIFIED_STATS';
const FETCH_UNVERIFIED_STATS_SUCCESS = 'crowdspring/admin/FETCH_UNVERIFIED_STATS_SUCCESS';

const FETCH_CLIENTS = 'crowdspring/admin/FETCH_CLIENTS';
const FETCH_CLIENTS_REQUEST = 'crowdspring/admin/FETCH_CLIENTS_REQUEST';
const FETCH_CLIENTS_SUCCESS = 'crowdspring/admin/FETCH_CLIENTS_SUCCESS';

const FETCH_CLIENT_STATS = 'crowdspring/admin/FETCH_CLIENT_STATS';
const FETCH_CLIENT_STATS_SUCCESS = 'crowdspring/admin/FETCH_CLIENT_STATS_SUCCESS';

const FETCH_CREATIVES = 'crowdspring/admin/FETCH_CREATIVES';
const FETCH_CREATIVES_REQUEST = 'crowdspring/admin/FETCH_CREATIVES_REQUEST';
const FETCH_CREATIVES_SUCCESS = 'crowdspring/admin/FETCH_CREATIVES_SUCCESS';

const FETCH_CREATIVE_STATS = 'crowdspring/admin/FETCH_CREATIVE_STATS';
const FETCH_CREATIVE_STATS_SUCCESS = 'crowdspring/admin/FETCH_CREATIVE_STATS_SUCCESS';

const FETCH_WAITERS = 'crowdspring/admin/FETCH_WAITERS';
const FETCH_WAITERS_REQUEST = 'crowdspring/admin/FETCH_WAITERS_REQUEST';
const FETCH_WAITERS_SUCCESS = 'crowdspring/admin/FETCH_WAITERS_SUCCESS';

const FETCH_WAITER_STATS = 'crowdspring/admin/FETCH_WAITER_STATS';
const FETCH_WAITER_STATS_SUCCESS = 'crowdspring/admin/FETCH_WAITER_STATS_SUCCESS';

const FETCH_SINGLE = 'crowdspring/admin/FETCH_SINGLE_PEOPLE';
const FETCH_SINGLE_REQUEST = 'crowdspring/admin/FETCH_SINGLE_PEOPLE_REQUEST';
const FETCH_SINGLE_SUCCESS = 'crowdspring/admin/FETCH_SINGLE_PEOPLE_SUCCESS';
const FETCH_SINGLE_FAILURE = 'crowdspring/admin/FETCH_SINGLE_PEOPLE_FAILURE';

const FETCH_IMPERSONATE = 'crowdspring/admin/FETCH_IMPERSONATE_PEOPLE';
const FETCH_IMPERSONATE_REQUEST = 'crowdspring/admin/FETCH_IMPERSONATE_PEOPLE_REQUEST';
const FETCH_IMPERSONATE_SUCCESS = 'crowdspring/admin/FETCH_IMPERSONATE_PEOPLE_SUCCESS';
const FETCH_IMPERSONATE_FAILURE = 'crowdspring/admin/FETCH_IMPERSONATE_PEOPLE_FAILURE';

const FETCH_PAYMENT_METHOD = 'crowdspring/admin/FETCH_PAYMENT_METHOD';
const FETCH_PAYMENT_METHOD_SUCCESS = 'crowdspring/admin/FETCH_PAYMENT_METHOD_SUCCESS';

const FETCH_OWNED_PROJECTS = 'crowdspring/admin/FETCH_OWNED_PROJECTS';
const FETCH_OWNED_PROJECTS_SUCCESS = 'crowdspring/admin/FETCH_OWNED_PROJECTS_SUCCESS';

const FETCH_PAYMENTS = 'crowdspring/admin/FETCH_USER_PAYMENTS';
const FETCH_PAYMENTS_REQUEST = 'crowdspring/admin/FETCH_USER_PAYMENTS_REQUEST';
const FETCH_PAYMENTS_SUCCESS = 'crowdspring/admin/FETCH_USER_PAYMENTS_SUCCESS';

const UPDATE_USER = 'crowdspring/admin/UPDATE_USER';
const UPDATE_USER_SUCCESS = 'crowdspring/admin/UPDATE_USER_SUCCESS';

const UPDATE_SPECIALIZATIONS = 'crowdspring/admin/UPDATE_SPECIALIZATIONS';
const UPDATE_SPECIALIZATIONS_SUCCESS = 'crowdspring/admin/UPDATE_SPECIALIZATIONS_SUCCESS';

const FETCH_RATINGS_RECEIVED = 'crowdspring/admin/FETCH_RATINGS_RECEIVED';
const FETCH_RATINGS_RECEIVED_SUCCESS = 'crowdspring/admin/FETCH_RATINGS_RECEIVED_SUCCESS';

const WATCH_SUB_CATEGORY = 'crowdspring/admin/WATCH_SUB_CATEGORY';
const UNWATCH_SUB_CATEGORY = 'crowdspring/admin/UNWATCH_SUB_CATEGORY';
const WATCH_SUB_CATEGORY_ONSITE = 'crowdspring/admin/WATCH_SUB_CATEGORY_ONSITE';
const UNWATCH_SUB_CATEGORY_ONSITE = 'crowdspring/admin/UNWATCH_SUB_CATEGORY_ONSITE';

const FETCH_PENDING_AWARDS = 'crowdspring/admin/FETCH_PENDING_AWARDS';
const FETCH_PENDING_AWARDS_SUCCESS = 'crowdspring/admin/FETCH_PENDING_AWARDS_SUCCESS';

const FETCH_PAYOUT_ACCOUNTS = 'crowdspring/admin/FETCH_PAYOUT_ACCOUNTS';
const FETCH_PAYOUT_ACCOUNTS_SUCCESS = 'crowdspring/admin/FETCH_PAYOUT_ACCOUNTS_SUCCESS';

const FETCH_PARTICIPATED_PROJECTS = 'crowdspring/admin/FETCH_PARTICIPATED_PROJECTS';
const FETCH_PARTICIPATED_PROJECTS_REQUEST = 'crowdspring/admin/FETCH_PARTICIPATED_PROJECTS_REQUEST';
const FETCH_PARTICIPATED_PROJECTS_SUCCESS = 'crowdspring/admin/FETCH_PARTICIPATED_PROJECTS_SUCCESS';

const FETCH_TESTIMONIALS = 'crowdspring/admin/FETCH_TESTIMONIALS';
const FETCH_TESTIMONIALS_SUCCESS = 'crowdspring/admin/FETCH_TESTIMONIALS_SUCCESS';

const DELETE_TESTIMONIAL = 'crowdspring/admin/DELETE_TESTIMONIAL';
const DELETE_TESTIMONIAL_SUCCESS = 'crowdspring/admin/DELETE_TESTIMONIAL_SUCCESS';

const UPDATE_HISTORY_PAYMENTS_PAGE = 'crowdspring/admin/UPDATE_HISTORY_PAYMENTS_PAGE';

const FETCH_REQUESTED_PAYMENTS = 'crowdspring/admin/FETCH_REQUESTED_PAYMENTS';
const FETCH_REQUESTED_PAYMENTS_SUCCESS = 'crowdspring/admin/FETCH_REQUESTED_PAYMENTS_SUCCESS';

const FETCH_HISTORY_PAYMENTS_PAGE = 'crowdspring/admin/FETCH_HISTORY_PAYMENTS_PAGE';
const FETCH_HISTORY_PAYMENTS_PAGE_SUCCESS = 'crowdspring/admin/FETCH_HISTORY_PAYMENTS_PAGE_SUCCESS';

const FETCH_REPUTATION_DATAPOINTS = 'crowdspring/admin/FETCH_REPUTATION_DATAPOINTS';
const FETCH_REPUTATION_DATAPOINTS_SUCCESS = 'crowdspring/admin/FETCH_REPUTATION_DATAPOINTS_SUCCESS';

const FETCH_LAST_WAITERS_INVITATION = 'crowdspring/admin/FETCH_LAST_WAITERS_INVITATION';
const FETCH_LAST_WAITERS_INVITATION_SUCCESS = 'crowdspring/admin/FETCH_LAST_WAITERS_INVITATION_SUCCESS';

const FETCH_WAITERS_TO_INVITE_COUNT = 'crowdspring/admin/FETCH_WAITERS_TO_INVITE_COUNT';
const FETCH_WAITERS_TO_INVITE_COUNT_REQUEST = 'crowdspring/admin/FETCH_WAITERS_TO_INVITE_COUNT_REQUEST';
const FETCH_WAITERS_TO_INVITE_COUNT_SUCCESS = 'crowdspring/admin/FETCH_WAITERS_TO_INVITE_COUNT_SUCCESS';

const FETCH_WAITER_INVITES = 'crowdspring/admin/FETCH_WAITER_INVITES';
const FETCH_WAITER_INVITES_REQUEST = 'crowdspring/admin/FETCH_WAITER_INVITES_REQUEST';
const FETCH_WAITER_INVITES_SUCCESS = 'crowdspring/admin/FETCH_WAITER_INVITES_SUCCESS';

const FETCH_EMAIL_DELIVERABILITY = 'crowdspring/admin/FETCH_EMAIL_DELIVERABILITY';
const FETCH_EMAIL_DELIVERABILITY_REQUEST = 'crowdspring/admin/FETCH_EMAIL_DELIVERABILITY_REQUEST';
const FETCH_EMAIL_DELIVERABILITY_SUCCESS = 'crowdspring/admin/FETCH_EMAIL_DELIVERABILITY_SUCCESS';

export const impersonateSuccess = createAction(FETCH_IMPERSONATE_SUCCESS);


/* HELPERS
================================================================================================ */
const HISTORY_PAYMENTS_PAGE_SIZE = 5;

const watchSubcategoryRequest = ({ userId, subcatId, frequency, dispatch }) => {
  return request.patch(
    `/api/v1/radmin/users/${userId}/subcat_watch_${frequency}/`, { sub_category: subcatId }
  ).catch(() => dispatch(setBannerError('Error watching subcategory', 'Please try again')));
}

const unwatchSubcategoryRequest = ({ userId, subcatId, dispatch }) => {
  return request.patch(
    `/api/v1/radmin/users/${userId}/subcat_unwatch_email/`, { sub_category: subcatId }
  ).catch(() => dispatch(setBannerError('Error unwatching subcategory', 'Please try again')));
}

const watchSubcategoryOnsiteRequest = ({ userId, subcatId, dispatch }) => {
  return request.patch(
    `/api/v1/radmin/users/${userId}/subcat_watch_onsite/`, { sub_category: subcatId }
  ).catch(() => dispatch(setBannerError('Error watching subcategory onsite', 'Please try again')));
}

const unwatchSubcategoryOnsiteRequest = ({ userId, subcatId, dispatch }) => {
  return request.patch(
    `/api/v1/radmin/users/${userId}/subcat_unwatch_onsite/`, { sub_category: subcatId }
  ).catch(() => dispatch(setBannerError('Error unwatching subcategory onsite', 'Please try again')));
}

export const inviteWaitersRequest = (data) => (
  request.put('/api/v1/creative-registration-waiters/invite_to_register/', data)
);

const updateSegments = (user, formData) => {
  const currentSegments = user.marketing_segments || [];
  const updatedSegments = [formData['segment']].concat(
    formData.is_product_entrepreneur === 'yes'? 'product_entrepreneur' : []
  );

  const toAdd = difference(updatedSegments, currentSegments);
  const toRemove = difference(currentSegments, updatedSegments);

  if (toAdd.length === 0 && toRemove.length === 0) {
    return Promise.resolve();
  }

  /* removal has to take place before new segments are added to avoid validation errors */
  let premises = toRemove.reduce((acc, segment) => (
    acc.then(() => request.patch(`/api/v1/users/${user.id}/remove_marketing_segment/`, {
      marketing_segment: segment
    }))
  ), Promise.resolve());
  premises = toAdd.reduce((acc, segment) => (
    acc.then(() => request.patch(`/api/v1/users/${user.id}/add_marketing_segment/`, {
      marketing_segment: segment
    }))
  ), premises);

  return premises;
}

/* INITIAL STATES
================================================================================================ */
export const initialState = {
  isFetching: false,
  isError: false,
  currentUser: null,
  tokens: {},
  unverified: [],
  unverifiedCount: 0,
  unverifiedStats: {},
  clients: [],
  clientsCount: 0,
  clientStats: {},
  creatives: [],
  creativesCount: 0,
  creativeStats: {},
  waiters: [],
  waitersCount: 0,
  waiterStats: {},
  paymentMethod: null,
  ownedProjects: [],
  ownedProjectsCount: 0,
  isFetchingPayments: false,
  payments: [],
  paymentsCount: 0,
  ratingsReceived: [],
  pendingAwards: [],
  payoutAccounts: [],
  isFetchingProjects: false,
  participatedProjects: [],
  participatedProjectsCount: 0,
  testimonials: [],
  historyPayments: {
    pages: [],
    currentPage: 1,
    pageCount: 0
  },
  requestedPayments: [],
  reputationDatapoints: {},
  lastWaitersInvitation: null,
  waitersToInviteCount: 0,
  fetchingWaitersToInviteCount: 0,
  isFetchingWaiterInvites: false,
  waiterInvites: [],
  waiterInvitesCount: 0,
  emailDeliveryStatus: 'unknown'
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_UNVERIFIED_SUCCESS:
      return {
        ...state,
        isFetching: false,
        unverified: action.payload.results,
        unverifiedCount: action.payload.count
      };
    case FETCH_UNVERIFIED_STATS_SUCCESS:
      return {
        ...state,
        unverifiedStats: action.payload
      };
    case FETCH_CLIENT_STATS_SUCCESS:
      return {
        ...state,
        clientStats: action.payload
      };
    case FETCH_CLIENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        clients: action.payload.results,
        clientsCount: action.payload.count
      };
    case FETCH_CREATIVE_STATS_SUCCESS:
      return {
        ...state,
        creativeStats: action.payload
      };
    case FETCH_CREATIVES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        creatives: action.payload.results,
        creativesCount: action.payload.count
      };
    case FETCH_WAITER_STATS_SUCCESS:
      return {
        ...state,
        waiterStats: action.payload
      };
    case FETCH_WAITERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        waiters: action.payload.results,
        waitersCount: action.payload.count
      };
    case FETCH_OWNED_PROJECTS_SUCCESS:
      return {
        ...state,
        ownedProjects: action.payload.results,
        ownedProjectsCount: action.payload.count
      };
    case FETCH_PAYMENTS_REQUEST:
      return {
        ...state,
        payments: [],
        paymentsCount: 0,
        isFetchingPayments: true
      };
    case FETCH_PAYMENTS_SUCCESS:
      return {
        ...state,
        payments: action.payload.results,
        paymentsCount: action.payload.count,
        isFetchingPayments: false
      };
    case FETCH_WAITERS_REQUEST:
    case FETCH_CREATIVES_REQUEST:
    case FETCH_CLIENTS_REQUEST:
    case FETCH_UNVERIFIED_REQUEST:
    case FETCH_SINGLE_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_SINGLE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        currentUser: action.payload,
      };
    case FETCH_IMPERSONATE_SUCCESS:
      const tokens = { ...state.tokens };
      tokens[action.payload.user_id] = action.payload.impersonation_token;

      return {
        ...state,
        tokens,
      };
    case FETCH_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        paymentMethod: action.payload.find((m) => m.default) || null
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.payload
      };
    case UPDATE_SPECIALIZATIONS_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          specializations: action.payload
        }
      };
    case FETCH_RATINGS_RECEIVED_SUCCESS:
      return {
        ...state,
        ratingsReceived: action.payload
      };
    case WATCH_SUB_CATEGORY:
      return {
        ...state,
        currentUser: updateSubcatWatchlists(
          false, 'watch', { ...state.currentUser }, action.payload.subcatId, action.payload.frequency
        )
      };
    case UNWATCH_SUB_CATEGORY:
      return {
        ...state,
        currentUser: updateSubcatWatchlists(
          false, 'unwatch', { ...state.currentUser }, action.payload.subcatId
        )
      };
    case WATCH_SUB_CATEGORY_ONSITE:
      return {
        ...state,
        currentUser: updateSubcatWatchlists(
          true, 'watch', { ...state.currentUser }, action.payload.subcatId
        )
      };
    case UNWATCH_SUB_CATEGORY_ONSITE:
      return {
        ...state,
        currentUser: updateSubcatWatchlists(
          true, 'unwatch', { ...state.currentUser }, action.payload.subcatId
        )
      };
    case FETCH_PENDING_AWARDS_SUCCESS:
      return {
        ...state,
        pendingAwards: action.payload
      };
    case FETCH_PAYOUT_ACCOUNTS_SUCCESS:
      return {
        ...state,
        payoutAccounts: action.payload
      };
    case FETCH_PARTICIPATED_PROJECTS_REQUEST:
      return {
        ...state,
        isFetchingProjects: true
      };
    case FETCH_PARTICIPATED_PROJECTS_SUCCESS:
      return {
        ...state,
        isFetchingProjects: false,
        participatedProjects: action.payload.results,
        participatedProjectsCount: action.payload.count
      };
    case FETCH_TESTIMONIALS_SUCCESS:
      return {
        ...state,
        testimonials: action.payload
      };
    case DELETE_TESTIMONIAL_SUCCESS:
      return {
        ...state,
        testimonials: state.testimonials.filter(t => t.id !== action.id)
      };
    case FETCH_REQUESTED_PAYMENTS_SUCCESS:
      return {
        ...state,
        requestedPayments: action.payload
      };
    case FETCH_HISTORY_PAYMENTS_PAGE_SUCCESS:
      const { historyPayments } = state;
      const pages = [...historyPayments.pages];
      pages[historyPayments.currentPage - 1] = action.payload.results;

      return {
        ...state,
        historyPayments: {
          ...historyPayments,
          pages,
          pageCount: Math.ceil(action.payload.count / HISTORY_PAYMENTS_PAGE_SIZE)
        }
      };
    case UPDATE_HISTORY_PAYMENTS_PAGE:
      return {
        ...state,
        historyPayments: {
          ...state.historyPayments,
          currentPage: parseInt(action.page)
        }
      };
    case FETCH_REPUTATION_DATAPOINTS_SUCCESS:
      return {
        ...state,
        reputationDatapoints: action.payload
      };
    case FETCH_LAST_WAITERS_INVITATION_SUCCESS:
      return {
        ...state,
        lastWaitersInvitation: action.payload.results[0]
      };
    case FETCH_WAITERS_TO_INVITE_COUNT_REQUEST:
      return {
        ...state,
        fetchingWaitersToInviteCount: true
      };
    case FETCH_WAITERS_TO_INVITE_COUNT_SUCCESS:
      return {
        ...state,
        waitersToInviteCount: action.payload.count,
        fetchingWaitersToInviteCount: false
      };
    case FETCH_WAITER_INVITES_REQUEST:
      return {
        ...state,
        isFetchingWaiterInvites: true
      };
    case FETCH_WAITER_INVITES_SUCCESS:
      return {
        ...state,
        isFetchingWaiterInvites: false,
        waiterInvites: action.payload.results,
        waiterInvitesCount: action.payload.count
      };
    case FETCH_EMAIL_DELIVERABILITY_REQUEST:
      return {
        ...state,
        emailDeliveryStatus: initialState.emailDeliveryStatus
      };
    case FETCH_EMAIL_DELIVERABILITY_SUCCESS:
      return {
        ...state,
        emailDeliveryStatus: (
          (action.payload.suppression_list_data || []).length === 0? "normal" : "suppressed"
        )
      };
    default:
      return state;
  }
}

export const getUnverifiedQueryString = (query) => {
  let preFilteredStatuses = ['submitted', 'waiting_for_creative'];
  /* if no preset is chosen, don't list creatives whose verification is in draft status */
  if (query.preset) {
    preFilteredStatuses = preFilteredStatuses.concat('draft');
  }

  const extraAPIQuery = {
    admin_preset: query.preset,
    is_creative: true,
    is_active: true,
  };

  /* pre-filter certain statuses only if not explicitly filtering by them */
  if (!some(Object.keys(query), k => k.includes('creative_verification_status'))) {
    extraAPIQuery.creative_verification_status = preFilteredStatuses;
  }

  return getAPIQueryString(UNVERIFIED_RESOURCE_NAME, query, { extraAPIQuery });
}

export const fetchUnverified = (query) => (dispatch) => {
  const queryStr = getUnverifiedQueryString(query);
  const promise = request.get(`/api/v1/users/?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(UNVERIFIED_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_UNVERIFIED,
    promise
  });
};

export const fetchUnverifiedStats = () => (dispatch) => {
  return dispatch({
    type: FETCH_UNVERIFIED_STATS,
    promise: request.get(`/api/v1/users/admin_stats_unverified/`)
  });
}

export const fetchClientStats = () => (dispatch) => {
  return dispatch({
    type: FETCH_CLIENT_STATS,
    promise: request.get(`/api/v1/users/admin_stats_client/`)
  });
}

export const fetchClients = (query) => (dispatch) => {
  const extraAPIQuery = {
    admin_preset: query.preset,
    is_valid_client: true,
  };
  const queryStr = getAPIQueryString(CLIENTS_RESOURCE_NAME, query, { extraAPIQuery });
  const promise = request.get(`/api/v1/users/?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(CLIENTS_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_CLIENTS,
    promise
  });
};

export const fetchCreativeStats = () => (dispatch) => {
  return dispatch({
    type: FETCH_CREATIVE_STATS,
    promise: request.get(`/api/v1/users/admin_stats_creative/`)
  });
}

export const fetchCreatives = (query) => (dispatch) => {
  const extraAPIQuery = {
    admin_preset: query.preset,
    is_creative: true,
  };
  const queryStr = getAPIQueryString(CREATIVES_RESOURCE_NAME, query, { extraAPIQuery });
  const promise = request.get(`/api/v1/users/?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(CREATIVES_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_CREATIVES,
    promise
  });
};

export const fetchWaiterStats = () => (dispatch) => {
  return dispatch({
    type: FETCH_WAITER_STATS,
    promise: request.get(`/api/v1/creative-registration-waiters/admin_stats/`)
  });
}

export const fetchWaiters = (query) => (dispatch) => {
  const extraAPIQuery = {
    admin_preset: query.preset,
  };
  const queryStr = getAPIQueryString(WAITERS_RESOURCE_NAME, query, { extraAPIQuery });
  const promise = request.get(`/api/v1/creative-registration-waiters/?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(WAITERS_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_WAITERS,
    promise
  });
};

export const fetchUser = id => dispatch => (
  dispatch({
    type: FETCH_SINGLE,
    promise: request.get(`/api/v1/users/${id}/`),
  })
);

export const impersonate = user_id => dispatch => (
  request.post('/api/v1/impersonate/', { user_id }).then(({ data }) => (
    dispatch(impersonateSuccess({ ...data, user_id }))
  ))
);

export const individualAdminActions = (id, action, fields, method="patch") => (dispatch, getState) => {
  const { people } = getState().admin;

  let data = fields;
  let url = `/api/v1/radmin/users/${id}/${action}/`;

  if (action === 'suspend') {
    const reactivate = moment(fields.reactivate, 'MM/DD/YYYY');
    if (!reactivate.isValid()) {
      window.alert('The reactivation date provided is not valid.');
      return Promise.reject();
    }
    data = { ...fields, reactivate: reactivate.format() };
  } else if (action === 'change_billing_info') {
    url = `/api/v1/users/${id}/`;
  } else if (action === 'delete_payment_method') {
    url = `/api/v1/users/${id}/payment-methods/delete/`;
    data = {
      id: people.paymentMethod.id
    };
  }

  let promise;

  if (action === 'change_client_segments') {
    promise = updateSegments(people.currentUser, data).then(() => dispatch(fetchUser(id)));
  } else {
    promise = request[method](url, data).then(() => {
      dispatch(fetchUser(id));

      if (action === 'delete_payment_method') {
        dispatch(fetchPaymentMethod(id));
      }

      if (['correct_reputation', 'recalculate_reputation'].includes(action)) {
        dispatch(fetchReputationDatapoints(id));
      }
    });
  }

  promise.catch(() => (
    dispatch(setBannerError('Error performing action', 'Please try again'))
  ));

  return promise;
};

export const peopleAdminActions = (id, action, fields, method="patch") => dispatch => (
  request[method](`/api/v1/radmin/users/${action}/`, fields)
);

export const fetchPaymentMethod = (userId) => (dispatch) => {
  return dispatch({
    type: FETCH_PAYMENT_METHOD,
    promise: request.get(`/api/v1/users/${userId}/payment-methods/`)
  });
}

export const fetchOwnedProjects = (userId, tab, query) => (dispatch) => {
  const STATUS_BY_TAB = {
    drafts: ['draft', '1_1_negotiating'],
    active: ['open', 'closed'],
    wrapup: ['awarded'],
    completed: ['completed', 'cancelled']
  };

  const extraAPIQuery = {
    status: STATUS_BY_TAB[tab]
  };
  const queryStr = getAPIQueryString(USER_PROJECTS_RESOURCE_NAME, query, { extraAPIQuery });
  const promise = request.get(`/api/v1/users/${userId}/projects_as_client/?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(USER_PROJECTS_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_OWNED_PROJECTS,
    promise
  });
}

export const fetchPayments = (userId, tab, query) => (dispatch) => {
  const extraAPIQuery = {
    status: tab === "refunded"? "refunded" : undefined,
    customer: userId
  };
  const queryStr = getAPIQueryString(USER_PAYMENTS_RESOURCE_NAME, query, {
    pageSize: USER_PAYMENTS_PAGE_SIZE,
    extraAPIQuery
  });
  const promise = request.get(`/api/v1/payments/?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(USER_PAYMENTS_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_PAYMENTS,
    promise
  });
}

export const updateUser = (id, data) => (dispatch) => {
  const promise = request.patch(`/api/v1/users/${id}/`, data);

  dispatch({
    type: UPDATE_USER,
    promise
  });

  promise.catch(() => dispatch(setBannerError('Error updating user', 'Please try again')));

  return promise;
}

export const updateSpecializations = (id, specializations) => (dispatch) => {
  const promise = request.put(`/api/v1/users/${id}/specializations/`, {
    specializations: (specializations || []).filter(s => !!s)
  });

  dispatch({
    type: UPDATE_SPECIALIZATIONS,
    promise
  });

  promise.catch(() => dispatch(setBannerError('Error updating specializations', 'Please try again')));

  return promise;
}

export const fetchRatingsReceived = (userId) => (dispatch) => {
  return dispatch({
    type: FETCH_RATINGS_RECEIVED,
    promise: request.get(`/api/v1/users/${userId}/ratings_received/`)
  });
}

export const unwatchAllCategories = () => (dispatch, getState) => {
  const state = getState();
  const userId = state.admin.people.currentUser.id;
  const cats = getWatchableCategories(state.categories.data);
  cats.forEach(cat => {
    cat.sub_categories.forEach(subcat => {
      dispatch({
        type: UNWATCH_SUB_CATEGORY,
        payload: { subcatId: subcat.id }
      });
    });
  });

  return request.patch(`/api/v1/radmin/users/${userId}/subcat_unwatch_email_all/`)
    .catch(() => dispatch(setBannerError('Error unwatching all categories', 'Please try again')));
}

export const watchSubcategory = (subcatId, frequency) => (dispatch, getState) => {
  const state = getState();
  const userId = state.admin.people.currentUser.id;

  dispatch({
    type: WATCH_SUB_CATEGORY,
    payload: { subcatId, frequency },
  });

  return watchSubcategoryRequest({ userId, subcatId, frequency, dispatch });
}

export const unwatchSubcategory = (subcatId) => (dispatch, getState) => {
  const state = getState();
  const userId = state.admin.people.currentUser.id;

  dispatch({
    type: UNWATCH_SUB_CATEGORY,
    payload: { subcatId },
  });

  return unwatchSubcategoryRequest({ userId, subcatId, dispatch });
}

export const watchCategory = (cat, frequency) => (dispatch, getState) => {
  const state = getState();
  const userId = state.admin.people.currentUser.id;

  reduce(cat.sub_categories, (acc, subcat) => {
    dispatch({
      type: WATCH_SUB_CATEGORY,
      payload: { subcatId: subcat.id, frequency }
    });

    /* make requests sequentially to avoid race conditions */
    return acc.then(_ => watchSubcategoryRequest({ userId, subcatId: subcat.id, frequency, dispatch }));
  }, Promise.resolve());
}

export const unwatchCategory = (cat) => (dispatch, getState) => {
  const state = getState();
  const userId = state.admin.people.currentUser.id;

  reduce(cat.sub_categories, (acc, subcat) => {
    dispatch({
      type: UNWATCH_SUB_CATEGORY,
      payload: { subcatId: subcat.id }
    });

    /* make requests sequentially to avoid race conditions */
    return acc.then(_ => unwatchSubcategoryRequest({ userId, subcatId: subcat.id, dispatch }));
  }, Promise.resolve());
}

export const watchSubcategoryOnsite = (subcatId) => (dispatch, getState) => {
  const state = getState();
  const userId = state.admin.people.currentUser.id;

  dispatch({
    type: WATCH_SUB_CATEGORY_ONSITE,
    payload: { subcatId },
  });

  return watchSubcategoryOnsiteRequest({ userId, subcatId, dispatch });
}

export const unwatchSubcategoryOnsite = (subcatId) => (dispatch, getState) => {
  const state = getState();
  const userId = state.admin.people.currentUser.id;

  dispatch({
    type: UNWATCH_SUB_CATEGORY_ONSITE,
    payload: { subcatId },
  });

  return unwatchSubcategoryOnsiteRequest({ userId, subcatId, dispatch });
}

export const watchCategoryOnsite = (cat) => (dispatch, getState) => {
  const state = getState();
  const userId = state.admin.people.currentUser.id;

  reduce(cat.sub_categories, (acc, subcat) => {
    dispatch({
      type: WATCH_SUB_CATEGORY_ONSITE,
      payload: { subcatId: subcat.id }
    });

    /* make requests sequentially to avoid race conditions */
    return acc.then(_ => watchSubcategoryOnsiteRequest({ userId, subcatId: subcat.id, dispatch }));
  }, Promise.resolve());
}

export const unwatchCategoryOnsite = (cat) => (dispatch, getState) => {
  const state = getState();
  const userId = state.admin.people.currentUser.id;

  reduce(cat.sub_categories, (acc, subcat) => {
    dispatch({
      type: UNWATCH_SUB_CATEGORY_ONSITE,
      payload: { subcatId: subcat.id }
    });

    /* make requests sequentially to avoid race conditions */
    return acc.then(_ => unwatchSubcategoryOnsiteRequest({ userId, subcatId: subcat.id, dispatch }));
  }, Promise.resolve());
}

export const resetNotificationSettings = (id, action, fields, method="patch") => (dispatch) => {
  const promise = request[method](`/api/v1/users/${id}/notifications/${action}/`, fields).then(() => {
    dispatch(fetchNotificationSettings(id));
  });

  promise.catch(() => (
    dispatch(setBannerError('Error performing action', 'Please try again'))
  ));

  return promise;
};

export const fetchPendingAwards = (userId) => (dispatch) => {
  return dispatch({
    type: FETCH_PENDING_AWARDS,
    promise: request.get(`/api/v1/users/${userId}/payout/unrequested-payments/`)
  });
}

export const fetchPayoutAccounts = (userId) => (dispatch, getState) => {
  return dispatch({
    type: FETCH_PAYOUT_ACCOUNTS,
    promise: request.get(`/api/v1/users/${userId}/payout/bindings/`)
  });
}

export const fetchParticipatedProjects = (userId, tab, query) => (dispatch) => {
  const STATUS_BY_TAB = {
    participating: ['open', 'closed', '1_1_negotiating'],
    wrapup: ['awarded'],
    won: ['completed', 'cancelled'],
    history: ['awarded', 'completed', 'cancelled'],
  };

  const AWARDED_BY_TAB = {
    wrapup: true,
    won: true,
    history: false
  };

  const extraAPIQuery = {
    status: STATUS_BY_TAB[tab],
    awarded: AWARDED_BY_TAB[tab]
  };
  const queryStr = getAPIQueryString(USER_PROJECTS_RESOURCE_NAME, query, {
    pageSize: CREATIVE_PROJECTS_PAGE_SIZE,
    extraAPIQuery
  });
  const promise = request.get(`/api/v1/users/${userId}/projects_as_creative/?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(USER_PROJECTS_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_PARTICIPATED_PROJECTS,
    promise
  });
}

export const fetchTestimonials = (userId) => (dispatch) => {
  return dispatch({
    type: FETCH_TESTIMONIALS,
    promise: request.get(`/api/v1/users/${userId}/testimonials/`)
  });
}

export const deleteTestimonial = (userId, id) => (dispatch) => {
  const promise = request.delete(`/api/v1/users/${userId}/testimonials/${id}/`);

  promise.catch(() => dispatch(setBannerError('Error deleting testimonial', 'Please try again')));

  dispatch({
    type: DELETE_TESTIMONIAL,
    promise,
    id
  });

  return promise;
}

export const updateHistoryPaymentsPage = (userId, page) => (dispatch, getState) => {
  const state = getState();
  const { pages } = state.admin.people.historyPayments;

  dispatch({
    type: UPDATE_HISTORY_PAYMENTS_PAGE,
    page
  });

  dispatch(fetchHistoryPaymentsPage(userId, page));
}

export const fetchHistoryPaymentsPage = (userId, page) => (dispatch) => {
  const offset = (page - 1) * HISTORY_PAYMENTS_PAGE_SIZE;
  const limit = HISTORY_PAYMENTS_PAGE_SIZE;

  return dispatch({
    type: FETCH_HISTORY_PAYMENTS_PAGE,
    promise: request.get(
      `/api/v1/users/${userId}/payout/requests/completed/?limit=${limit}&offset=${offset}`
    )
  });
}

export const fetchRequestedPayments = (userId) => (dispatch) => {
  return dispatch({
    type: FETCH_REQUESTED_PAYMENTS,
    promise: request.get(`/api/v1/users/${userId}/payout/requests/in_progress/`)
  });
}

export const fetchReputationDatapoints = (userId) => (dispatch) => {
  return dispatch({
    type: FETCH_REPUTATION_DATAPOINTS,
    promise: request.get(`/api/v1/users/${userId}/reputation_datapoints/`)
  });
}

export const fetchLastWaitersInvitation = () => (dispatch) => {
  return dispatch({
    type: FETCH_LAST_WAITERS_INVITATION,
    promise: request.get('/api/v1/creative-registration-waiters/registration_invite_lists/')
  });
}

export const fetchWaitersToInviteCount = (criteria) => (dispatch) => {
  const { intendedSubcats, createdAtSince, createdAtUntil } = criteria;
  const params = queryString.stringify({
    intended_sub_category_ids: intendedSubcats,
    created_at__gte: createdAtSince,
    created_at__lte: createdAtUntil
  });

  return dispatch({
    type: FETCH_WAITERS_TO_INVITE_COUNT,
    promise: request.get(`/api/v1/creative-registration-waiters/?${params}`)
  });
}

export const fetchWaiterInvites = (query) => (dispatch) => {
  const queryStr = getAPIQueryString(WAITER_INVITES_RESOURCE_NAME, query);
  const promise = request.get(
    `/api/v1/creative-registration-waiters/registration_invite_lists/?${queryStr}`
  );

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(WAITER_INVITES_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_WAITER_INVITES,
    promise
  });
};

export const fetchEmailDeliverability = (userId) => (dispatch) => {
  return dispatch({
    type: FETCH_EMAIL_DELIVERABILITY,
    promise: request.get(`/api/v1/users/${userId}/deliverability/`)
  });
}



// WEBPACK FOOTER //
// ./admin/ducks/people.js